import React from 'react';
import ReactPlayer from 'react-player';

interface ReactPlayerComponentProps {
    file: any;
}

export const ReactPlayerComponent = ({ file }: ReactPlayerComponentProps) => (
    <div className="react-player-wrapper">
        <div className="react-player-inner">
            <ReactPlayer height="100%" width="100%" url={file} controls />
        </div>
    </div>
);